import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import { PERSONAL_REFERENCE_LOADING, PERSONAL_REFERENCE_SUCCESS, PERSONAL_REFERENCE_FAILED, SAVE_PERSONAL_REFERENCE_LOADING, SAVE_PERSONAL_REFERENCE_SUCCESS, SAVE_PERSONAL_REFERENCE_FAILED } from '../Constants/personalReferenceConstants';
import { handleApiError } from "../Helper/actionHelper";

export const personalReference = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    dispatch({ type: PERSONAL_REFERENCE_LOADING });

    const requestData = {
      token: userLocalData.id,
      group: '6',
      referenceNo: userLocalData.reference,
    };

    //return false;
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    const { data } = await axios.post(FOLDERPATH + 
      "/CandidateApi/checkDetail", 
      requestData,
      {
        headers: headers,
      }

    );

    dispatch({
      type: PERSONAL_REFERENCE_SUCCESS,
      payload: data,
    });

    handleApiError(data);

  } catch (error) {
    dispatch({
      type: PERSONAL_REFERENCE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const savePersonalReference = (record) =>
  async (dispatch) => {
    try {
      dispatch({ type: SAVE_PERSONAL_REFERENCE_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate')); 

    const requestData = {
      token:
      userLocalData.id,
      ...record
    };

    console.log(requestData);
    
    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data:result } = await axios.post(FOLDERPATH + 
      "/CandidateApi/saveCheckDetails",
      requestData,
      {
        headers: headers,
      } 
    );

    if (result.status === "success") {

      const { data } = result;

    dispatch({
      type: SAVE_PERSONAL_REFERENCE_SUCCESS,
      payload: data,
    });

    const msg = "Saved Successfully";

    toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  }

    handleApiError(result);
    } catch (error) {
      dispatch({
        type: SAVE_PERSONAL_REFERENCE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
      handleApiError(error);
    }
  };

  export const deleteSavePrReferenceDetails = () => (dispatch) => {
  dispatch({
    type: SAVE_PERSONAL_REFERENCE_SUCCESS,
    payload: [],
  });
};